import { render } from "./IDLogin.vue?vue&type=template&id=491464ee&scoped=true"
import script from "./IDLogin.vue?vue&type=script&lang=js"
export * from "./IDLogin.vue?vue&type=script&lang=js"

import "./IDLogin.vue?vue&type=style&index=0&id=491464ee&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-491464ee"]])

export default __exports__